import { diaryByIdQueryOptions } from "@/features/diaries/api/diaryQueryOptions";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import ErrorPage from "../../../components/pages/ErrorPage";

const DiaryId = () => {
	return (
		<div className="md-width">
			<Outlet />
		</div>
	);
};
export const Route = createFileRoute("/_app/diaries/$diaryId")({
	beforeLoad: ({ context }) => {
		return {
			auth: context.auth,
		};
	},
	loader: async ({ context, params }) => {
		const diary = await context?.queryClient.ensureQueryData(
			diaryByIdQueryOptions(params.diaryId),
		);
		return { diary };
	},
	component: DiaryId,
	errorComponent: ({ error, reset }) => (
		<ErrorPage title="Diary Error" error={error} reset={reset} />
	),
});
